import {BaseDTO} from "./_baseDTO.interface";

export interface RoleDTO extends BaseDTO {
  roleName: string;
}
